<template>
  <v-container fluid grid-list-lg class="datatable__actions">
    <v-layout row wrap justify-space-between align-center class="page-layout">
      <v-flex d-flex justify-center align-center class="border-area at-left">
        <v-pagination
          v-model="pagination.page"
          :length="totalPages"
          :total-visible="7"
        ></v-pagination>
      </v-flex>
      <v-flex justify-center align-center class="flexbox border-area at-right">
        <div v-if="rowsPerPageItems">
          <v-select
            :aria-label="rowsPerPageText"
            :items="rowsPerPageItems"
            v-model="pagination.rowsPerPage"
            :menu-props="{ auto: true, minWidth: '50px' }"
            :hideDetails="false"
            :messages="rowsPerPageText"
          ></v-select>
        </div>
        <div class="ml-3 mr-1">
          {{ paginationText }}
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: {
      rowsPerPageItems: { type: Array, required: false, default: () => [10, 50, 100, 500] },
      pagination: { type: Object, required: false, default: () => ({ rowsPerPage: 10 }) }
    },
    data () {
      return {
        rowsPerPageText: 'Rows per page'
      }
    },
    watch: {
      'pagination.rowsPerPage': {
        deep: true,
        handler (val) {
          this.pagination.page = 1
          this.$emit('update:pagination', this.pagination)
        }
      },
      'pagination': {
        deep: true,
        handler () {
          this.$nextTick(() => {
            if (this.pageStart > this.pageLimit) {
              this.pagination.page = 1
              this.$emit('update:pagination', this.pagination)
            }
          })
        }
      }
    },
    computed: {
      totalPages () {
        const { pagination: { rowsPerPage, totalItems } } = this
        return rowsPerPage ? Math.ceil(totalItems / rowsPerPage) : 0
      },
      pageStart () {
        return (this.pagination.page - 1) * this.pagination.rowsPerPage
      },
      pageStop () {
        return this.pagination.page * this.pagination.rowsPerPage
      },
      pageLimit () {
        return this.pagination.totalItems && (this.pagination.totalItems < this.pageStop || this.pageStop < 0)
          ? this.pagination.totalItems
          : this.pageStop
      },
      paginationText () {
        let paginationText = '–'
        if (this.pagination.totalItems) {
          paginationText = `${this.pageStart + 1}-${this.pageLimit} of ${this.pagination.totalItems}`
        }
        return paginationText
      }
    }
  }
</script>

<style lang="scss" scoped>
  $text-color: rgba(0, 0, 0, 0.54);
  .datatable__actions {
    color: $text-color !important;
  }
  .d-flex > *,
  .d-inline-flex > * {
    flex: none;
  }
  .page-layout {
    overflow: auto;
  }
  @media screen and (min-width: 960px) {
    .border-area {
      &.at-left {
        justify-content: flex-start;
      }
      &.at-right {
        justify-content: flex-end;
      }
    }
  }
</style>
